import { render } from "./TrimPaint.vue?vue&type=template&id=3beee1d6"
import script from "./TrimPaint.vue?vue&type=script&lang=js"
export * from "./TrimPaint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__